<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion-carta' }">{{
                $t("configuracionCarta")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              <router-link :to="{ name: 'planificador-carta' }">{{
                $t("ProgramacionCarta")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Crear planificación
            </li>
          </ol>
        </nav>
      </div>
      <div class="card col-md-12">
        <div class="row">
          <div style="margin-left: 20px">
            <h2 class="tituloNumier"><i class="fa fa-building"></i> {{nombreNegocio}}</h2>
          </div>
        </div>
        <div>
          <div class="col-md-12">
            <div style="margin-top: 10px">
              <div class="row">
                <div class="col-md">
                  <div class="form-group">
                    <label for="nameProducto"
                      ><strong
                        >{{ $t("aliasMayuscula") }} </strong
                      ></label
                    >
                    <input type="text" class="form-control" placeholder="Escribe un alias..." v-model="alias" />
                  </div>
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label
                      ><strong>{{ $t("fecha") }}</strong></label
                    >
                    <datetime
                      :value-zone="timezoneId"
                      :auto="true"
                      class="theme-numier"
                      format="dd-MM-yyyy"
                      :title="$t('fecha')"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      v-model="datefrom"
                    ></datetime>
                  </div>
                </div>

                <!--<div class="col-md">
                  <div class="form-group">
                    <label
                      ><strong>{{ $t("fechaFin") }}</strong></label
                    >
                    <datetime
                      :auto="true"
                      class="theme-numier"
                      :value-zone="timezoneId"
                      :title="$t('fechaFin')"
                      format="dd-MM-yyyy"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      v-model="dateto"
                    ></datetime>
                  </div>
                </div>-->
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="clientes"
                    ><strong
                      >{{ $t("buscarSinPuntos") }} productos</strong
                    ></label
                  >
                  <el-select
                    class="select-default"
                    size="large"
                    v-model="idProductCarta"
                    filterable
                    remote
                    @change="addProduct()"
                    :placeholder="'Escribe el nombre del producto...'"
                    :remote-method="searchProduct"
                  >
                    <el-option
                      v-for="p in listProduct"
                      class="select-primary"
                      :value="p.id"
                      :label="p.nameProducto + ' [' + p.nameCategoria + ']' + (p.baja ? ' [BAJA]' : '')"
                      :key="p.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-8" style="margin-top: 28px">
                <div class="form-group">
                  <div class="btn btn-danger btn-link btn-xs">
                    <el-checkbox v-model="isPublicado">
                      <template></template>
                      <strong>{{
                          "Publicar"
                      }}
                      </strong>
                    </el-checkbox>
                  </div>
                  <label>&nbsp;</label>
                  <button
                    class="btn btn-primary"
                    @click="modo == 0 ? addCartasProgramadas() : modificarCarta()"
                  >
                    <i class="fa fa-check-square"></i> {{ $t("guardar") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="col-md-12">
              <table class="table table-bordered table-striped text-nowrap">
                <thead class="thead-dark">
                  <tr style="cursor: pointer">
                    <th><i style="color: white"></i> {{ $t("nombre") }}</th>
                    <th><i style="color: white"></i> {{ $t("categoria") }}</th>
                    <th><i style="color: white"></i> {{ $t("precio") }}</th>
                    <th><i style="color: white"></i>{{ $t("acciones") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(obj, index) in list">
                    <td>{{ obj.nameProducto }} <span v-if="obj.baja" class="text-danger">[BAJA]</span></td>
                    <td>{{ obj.nameCategoria }}</td>
                    <td>{{ obj.price1 | currency}}</td>
                    <td align="center">
                      <i
                        class="fa-solid fa-trash-alt text-danger"
                        @click="borrarProducto(index, obj.idProductCartaProgramada)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading,
  Radio,
  CheckboxGroup,
  Checkbox,
} from "element-ui";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import swal from "sweetalert2";
import moment from "moment";
import { forEach } from "mathjs";

export default {
  created() {

    this.loading = Loading.service({ text: "Cargando..." });
    // this.list = [];
    this.listidProduct = [];
    this.$store.dispatch("setNameRoute", this.$i18n.t("ProgramacionCarta"));

    this.idBusiness = this.$route.params.idBusiness;
    this.cartaProgramada = this.$route.params.CartaProgramada;
    this.modo = this.$route.params.modo;

    
    if (this.cartaProgramada != null) {

      let fechaInicio = new Date(this.cartaProgramada.fechaInicio * 1000);
      fechaInicio = fechaInicio.toISOString();
      let fechaFin = new Date(this.cartaProgramada.fechaFin * 1000);
      fechaFin = fechaFin.toISOString();

      this.idCarta = this.cartaProgramada.id;
      this.alias = this.cartaProgramada.Alias;
      this.datefrom = fechaInicio;
      this.dateto = fechaFin;
      // console.log(this.cartaProgramada.isPublicado);
      this.isPublicado = this.cartaProgramada.isPublicado;
    }

    this.identificacionNegocio();
    
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date().toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: 0,
      mode: 0,
      cartaProgramada: null,
      contador: 0,
      listTpv: [],
      idTpv: -1,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },
      list: [],
      listProduct: [],
      listidProduct: [],
      idProduct: 0,
      idProductCarta: null,

      namecategoria: "",
      //Daros de la carta

      idCarta: 0,
      alias: "",
      fechaInicio: "",
      fechaFin: "",
      isPublicado: 0,

      respuesta: true,
      modo: 0,
      index: 0,
      productoAdd: null,
      cambios: false,
      nombreNegocio: "",
    };
  },
  computed: {
    timezoneId() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
  },
  methods: {
    identificacionNegocio() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/identifyBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.nombreNegocio = response.data.result;
            if (vm.cartaProgramada != null) {
              vm.getProductCartaProgramada();
            } else {
              vm.loading.close();
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.loading.close();
          }
        });
    },
    searchProduct(query) {
      if (query !== "") {
        const controller = "searchProductCarta/" + query;
        var config = {
          params: {
            idBusinessInfo: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "delivery/" + controller, config)
          .then(function (response) {
            if (response.data.response) {
              vm.listProduct = response.data.result;
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    addProduct() {
      //(this.cartaProgramada);
      this.loading = Loading
      if (this.cartaProgramada == null) {
        let vm = this;
        var existe = false;
        this.listProduct.forEach(function (x) {
          if (x.id === vm.idProductCarta) {
            vm.productoAdd = x;
          }
        });

        for (var i = 0; i < this.list.length; i++) {
          if (this.list[i].id === vm.productoAdd.id) {
           // console.log(this.list[i]);
            swal({
              text: "El producto :" + this.list[i].nameProducto + " ya existe",
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
            existe = true;
            break;
          }
        }
        if (!existe) {
          this.cambios = true;
          vm.list.push(vm.productoAdd);
        }

        vm.listProduct = [];
        vm.idProductCarta = "";
      } else {

        this.loading = Loading.service({ text: "Cargando..." });

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idProductoCarta: this.idProductCarta,
          idCartaProgramada: this.idCarta,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "createProductoProgramacionCarta";
        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {
              vm.$notify({
                message: "Producto añadido correctamente",
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              })
              vm.idProductCarta = "";
              //vm.loading = Loading.service({ text: "Cargando..." });
              vm.getProductCartaProgramada();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    getProductCartaProgramada() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idCarta: this.idCarta,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/getProductsCartaProgramada",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.list = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

          vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    addCartasProgramadas() {
      this.loading = Loading.service({ text: "Cargando..." });
      
      const datefrom = new Date(this.datefrom);
      this.dateto = new Date();
      this.dateto.setDate(datefrom.getDate() + 1);

      let estado = this.isPublicado ? 1 : 0;
      let vm = this;
      // console.log(estado);
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        this.loading.close();
      } else {
        /*let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          this.loading.close();
        } else {*/
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          if (this.idTpv == -1) {
            this.idTpvAMandar = 0;
          } else {
            this.idTpvAMandar = this.idTpv;
          }
        /*}*/
        this.getListidProduct();
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
            jwt: vm.$store.getters.jwt,
            idBusiness: this.idBusiness,
            alias: this.alias,
            fechaInicio: moment(this.datefrom).startOf("day").unix(),
            fechaFin: moment(this.datefrom).endOf("day").unix(),
            idTpv: 0,
            listProduct: this.listidProduct,
            estado: estado,
        }
  

        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/addCartasProgramadas",
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              if (estado == 0) {

                vm.$notify({
                  message: "Planificación guardada correctamente",
                  icon: "nc-icon nc-check-2",
                  timeout: 2000,
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success",
                });
                
                vm.$router.push({
                  name: "planificador-carta",
                });

              } else {
                vm.$notify({
                  message: "Planificación guardada y publicada correctamente",
                  icon: "nc-icon nc-check-2",
                  timeout: 2000,
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success",
                });
                
                vm.$router.push({
                  name: "planificador-carta",
                });
              }
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          });
        
      }
    },

    getListidProduct() {
      this.list.forEach((element, index) => {
        this.listidProduct.push(element.id);
      });
    },
    borrarProducto(id, idProductoCartaProgramada) {

      if (this.cartaProgramada != null) {
        this.borrarProductoCartaProgramada(idProductoCartaProgramada);
      } else {
        this.list.splice(id, 1);
      }
    },
    borrarProductoCartaProgramada(idProducto){
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idProductoCartaProgramada: idProducto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "eliminarProductoProgramacionCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$notify({
              message: "Producto eliminado correctamente",
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            })
            vm.loading = Loading.service({ text: "Cargando..." });
            vm.getProductCartaProgramada();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    modificarCarta() {
      this.loading = Loading.service({ text: "Cargando..." });
      
      const datefrom = new Date(this.datefrom);
      this.dateto = new Date();
      this.dateto.setDate(datefrom.getDate() + 1);

      let estado = this.isPublicado ? 1 : 0;
      let vm = this;
      // console.log(estado);

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        this.loading.close();
      } else {
        /*let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          this.loading.close();
        } else {*/
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          if (this.idTpv == -1) {
            this.idTpvAMandar = 0;
          } else {
            this.idTpvAMandar = this.idTpv;
          }
        //}
        this.getListidProduct();
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          jwt: vm.$store.getters.jwt,
          idCarta: this.idCarta,
          idBusiness: this.idBusiness,
          alias: this.alias,
          fechaInicio: moment(this.datefrom).startOf("day").unix(),
          fechaFin: moment(this.datefrom).endOf("day").unix(),
          idTpv: 0,
          listProduct: this.listidProduct,
          estado: estado,
        };

        this.axios
          .post(this.$store.getters.apiUrl + "delivery/modificarCarta", params, config)
          .then(function (response) {
            if (response.data.response) {
              if (estado == 0) {
                vm.$notify({
                  message: "Planificación guardada correctamente",
                  icon: "nc-icon nc-check-2",
                  timeout: 2000,
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success",
                });
                
                vm.$router.push({
                  name: "planificador-carta",
                });
              } else {
                vm.$notify({
                  message: "Planificación guardada y publicada correctamente",
                  icon: "nc-icon nc-check-2",
                  timeout: 2000,
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success",
                });
                
                vm.$router.push({
                  name: "planificador-carta",
                });
              }
            }
          });
      }
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/PlanificacionCarta/PlanificacionCarta.vue